import { PropertyColumns } from '@miq/catalog';
import { PropertySetFilterLabelComponent } from '../../filter-item/custom/property-set-filter-label.component';

export default {
  [PropertyColumns.PropertySets_PropertySet]: {
    LabelRenderer: PropertySetFilterLabelComponent,
  },
  [PropertyColumns.Lease_PropertySet]: {
    LabelRenderer: PropertySetFilterLabelComponent,
  },
  [PropertyColumns.Availability_PropertySet]: {
    LabelRenderer: PropertySetFilterLabelComponent,
  },
  [PropertyColumns.Sale_PropertySet]: {
    LabelRenderer: PropertySetFilterLabelComponent,
  },
};
